import React, { useEffect } from 'react';

interface SeoProps {
  title: string;
  description: string;
  keywords: string;
  structuredData?: object | object[];
}

export const Seo: React.FC<SeoProps> = ({ title, description, keywords, structuredData }) => {
  useEffect(() => {
    document.title = title;

    const updateMetaTag = (name: string, content: string) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (meta) {
        meta.setAttribute('content', content);
      } else {
        meta = document.createElement('meta');
        meta.setAttribute('name', name);
        meta.setAttribute('content', content);
        document.head.appendChild(meta);
      }
    };

    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);

    const scriptElements: HTMLScriptElement[] = [];
    if (structuredData) {
      const dataArray = Array.isArray(structuredData) ? structuredData : [structuredData];
      dataArray.forEach(data => {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.text = JSON.stringify(data);
        script.setAttribute('data-seo-component', 'true');
        document.head.appendChild(script);
        scriptElements.push(script);
      });
    }

    return () => {
      document.querySelectorAll('script[data-seo-component="true"]').forEach(el => el.remove());
    };
  }, [title, description, keywords, structuredData]);

  return null;
};